import axios from 'axios'
import qs from 'qs'
import { getAuth } from 'firebase/auth'

const { REACT_APP_PUBLIC_API } = process.env

const http = axios.create({
	baseURL: `${REACT_APP_PUBLIC_API}`,
	paramsSerializer(params) {
		return qs.stringify(params, { indices: false })
	},
})

http.interceptors.request.use(
	(config) => {
		const { currentUser } = getAuth()
		config.headers = {
			...config.headers,
			'x-userid': currentUser.uid,
			Authorization: `Bearer ${currentUser.accessToken}`,
		}

		return config
	},
	(error) => Promise.reject(error),
)

http.interceptors.response.use(
	(response) => response,
	async (error) => {
		if (error.response && error.response.status === 401) {
			const originalRequest = error.config
			if (!originalRequest._retry) {
				originalRequest._retry = true
				const { currentUser } = getAuth()
				const token = await currentUser.getIdToken(true)
				axios.defaults.headers.common['Authorization'] = `Bearer ${token}`
				return http(originalRequest)
			} else {
				window.location.pathname = '/login'
			}
		} else if (error.response && error.response.status === 500) {
			return Promise.reject(error.response)
		} else return Promise.reject(error)
	},
)

export default http
